<!--
   Created by Terence on 2023/12/7 - 14:33
-->
<template>
  <video-post
    v-if="isVideoPost"
    :post-data="postData"
    :detail-data="detailData"
    :post-id="postId"
    :loading="loading"
    :error-text="errorText"
  />
  <template v-else>
    <download-banner @onInvokeApp="onInvokeApp" />
    <hover-guide-btn
      @onInvokeApp="onInvokeApp"
      :extStyle="{ bottom: '26.666666666666668rem' }"
    />
    <div class="detail-header island-header">
      <img
        v-if="islandInfo?.image"
        :width="100"
        :src="islandInfo?.image"
        alt="island封面图"
        class="island-cover"
      />
      <view class="island-info">
        <view class="island-name otext u-flex-c">
          <div class="island-name-content">
            <div>{{ islandInfo?.name || "-" }}</div>
            <DuTag style="border-radius: 2px" size="mini" bg="solid">
              岛
            </DuTag>
          </div>
          <DuIcon size="8px" name="arrow-right" class="island-name-icon" />
        </view>
        <view class="island-baseinfo u-flex-c">
          <text class="join-count">
            {{ `${islandInfo?.joinCount || "0"}人加入` }}
          </text>
        </view>
      </view>
    </div>
    <div class="post">
      <div class="post-header">
        <van-image
          fit="cover"
          class="post-header-avatar"
          :src="authorAvatar ? authorAvatar + '!mfit_w480_h480_jpg' : ''"
          alt=""
        />
        <div class="post-header-user">
          <div class="post-header-user-name">
            {{ authorName }}
          </div>
          <div class="post-header-user-time">
            <!--          TODO timeFormate  -->
            {{ createdAtText }}&nbsp;发布
            <span v-if="sectionInfo?.name"
              >在<span
                class="post-header-user-time-section"
                @click="handleToSection(sectionInfo)"
              >
                {{ sectionInfo?.name
                }}<ArrowRight :style="{ marginLeft: '0.5333333333333333rem' }" />
              </span>
            </span>
            <span v-else>该帖子</span>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div class="nickname" v-if="postData.title">{{ postData.title }}</div>
        <DuButton
          type="secondary"
          size="mini"
          color="primary"
          icon="arrow-right"
          icon-position="right"
          @click="handleFollowPost"
        >
          跟帖
        </DuButton>
      </div>
      <div class="post-content">
        {{ postData.content }}
      </div>
      <div class="post-imgs" v-if="imageAttachments.length">
        <grid-imgs :imgs="imageAttachments" />
      </div>
      <div class="post-region" v-if="postData.regionInfo?.province?.name">
        {{ postData.regionInfo?.province?.name }}
      </div>

      <!--  评论列表  -->
      <!--    TODO tokenId-->
      <comment-list v-if="postData.id" :postId="postData.id" type="post" />

      <div class="post-thumb">
        <Thumb
          :likeCount="postData.likeCount"
          :dislikeCount="postData.dislikeCount"
          :myAction="postData.myLike"
          @onClickThumb="onInvokeApp"
        />
      </div>
    </div>
  </template>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Image as VanImage } from "vant";
import { DuTag, DuIcon, DuButton } from "dangoui";
import dayjs from "dayjs";
import NftApi from "@/apis";
import DownloadBanner from "@/components/DownloadBanner/index.vue";
import { invokeAppByYYB } from "@/utils/mob";
import HoverGuideBtn from "@/components/HoverGuideBtn/index.vue";
import GridImgs from "@/components/GridImgs/index.vue";
import CommentList from "@/components/CommentList/index.vue";
import Thumb from "@/components/Thumb/index.vue";
import ArrowRight from "@/components/ArrowRight/index.vue";
import VideoPost from "./VideoPost.vue";

const route = useRoute();
const router = useRouter();
const postData = ref({});
const detailData = ref({});
const islandData = ref(null);
const loading = ref(true);
const errorText = ref("");

const postId = computed(() => String(route.query.postId || ""));

const firstAttachment = computed(() => postData.value.attachments?.[0] || {});

const isVideoPost = computed(() => {
  const queryType = String(route.query.postType || "").toLowerCase();
  const contentType = String(
    postData.value.postContentType || ""
  ).toUpperCase();
  const attachmentType = String(firstAttachment.value.type || "").toLowerCase();

  return (
    queryType === "video" ||
    contentType === "VIDEO" ||
    attachmentType === "video" ||
    Boolean(firstAttachment.value.videoUrls?.length)
  );
});

watch(
  isVideoPost,
  (value) => {
    if (value && String(route.query.postType || "").toLowerCase() !== "video") {
      router.replace({
        query: {
          ...route.query,
          postType: "video",
        },
      });
    }
  },
  { immediate: true }
);

const onInvokeApp = () => {
  invokeAppByYYB({
    targetPath: "community/post/detail",
    params: {
      id: postId.value,
    },
  });
};

const islandInfo = computed(() => {
  const island = islandData.value || postData.value?.standardData?.island;

  if (!island) {
    return null;
  }

  return {
    ...island,
    image: island.image || island.cover || "",
  };
});

const sectionInfo = computed(() => {
  return (
    postData.value?.standardData?.island?.sections?.[0] ||
    islandInfo.value?.sections?.[0] ||
    null
  );
});

const authorAvatar = computed(() => {
  const author = postData.value.user || postData.value.creator || {};
  return author.avatar || author.avatarUrl || "";
});

const authorName = computed(() => {
  const author = postData.value.user || postData.value.creator || {};
  return author.nickName || author.displayName || "-";
});

const createdAtText = computed(() => {
  if (!postData.value.createdAt) {
    return "-";
  }

  return dayjs(+postData.value.createdAt).format("YYYY-MM-DD");
});

const imageAttachments = computed(() => {
  if (!Array.isArray(postData.value.attachments)) {
    return [];
  }

  return postData.value.attachments
    .map((item) => (typeof item === "string" ? item : item?.url))
    .filter(Boolean);
});

const handleToSection = (section) => {
  invokeAppByYYB({
    targetPath: "community/post/label",
    params: {
      id: section?.id,
    },
  });
};

const initPostData = async () => {
  if (!postId.value) {
    errorText.value = "缺少帖子信息";
    loading.value = false;
    return;
  }

  try {
    const response = await NftApi.getPostInfo({
      postId: postId.value,
    });
    const detail = response?.data;

    if (!detail?.post) {
      errorText.value = response?.message || "帖子不存在或已被删除";
      return;
    }

    postData.value = detail.post;
    detailData.value = detail;
    islandData.value = detail.island || null;
  } catch (error) {
    errorText.value = "帖子加载失败，请稍后重试";
  } finally {
    loading.value = false;
  }
};

function handleFollowPost() {
  invokeAppByYYB({
    targetPath: "community/post/detail",
    params: {
      id: postId.value,
    },
  });
}

initPostData();
</script>

<style lang="scss">
.post {
  background-color: #fff;
  padding: 32rpx 30rpx 180rpx 30rpx;
  min-height: 100vh;
  &-header {
    display: flex;
    align-items: center;
    margin-bottom: 34rpx;
    &-avatar {
      width: 76rpx;
      height: 76rpx;
      border-radius: 100%;
      overflow: hidden;
      border: 2rpx solid rgba(0, 0, 0, 0.04);
    }
    &-user {
      margin-left: 16rpx;
      &-name {
        color: #000;
        font-size: 28rpx;
        font-style: normal;
        font-weight: 500;
        line-height: 44rpx; /* 157.143% */
      }
      &-time {
        display: flex;
        align-items: center;
        margin-top: 2rpx;
        color: rgba(0, 0, 0, 0.5);
        font-size: 20rpx;
        font-style: normal;
        font-weight: 400;
        line-height: 22rpx; /* 110% */
        &-section {
          margin-left: 4rpx;
          color: rgba(0, 0, 0, 0.7);
          font-size: 20rpx;
          font-style: normal;
          font-weight: 500;
          line-height: 22rpx; /* 110% */
        }
      }
    }
  }
  &-content {
    overflow: hidden;
    color: #000;
    font-size: 32rpx;
    font-style: normal;
    font-weight: 400;
    line-height: 56rpx; /* 175% */
  }
  &-imgs {
    margin-top: 24rpx;
  }
  &-region {
    margin-top: 24rpx;
    display: flex;
    align-items: center;
    align-self: stretch;
  }
  &-thumb {
    padding: 16rpx 30rpx 68rpx 30rpx;
    width: 750rpx;
    margin-top: 32rpx;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
  }

  .section {
    margin-top: 48rpx;
    &-title {
      color: #000;
      font-size: 40rpx;
      font-style: normal;
      font-weight: 500;
      line-height: 52rpx; /* 130% */
    }
  }
}

.nickname {
  font-weight: 500;
  font-size: 36rpx;
  line-height: 50rpx;
  color: #0c0c0c;
}
.island-cover {
  width: 48px;
  height: 48px;
  border-radius: 4px;
}

.island-info {
  flex: 1;
  margin-left: 16rpx;

  .island-name {
    font-weight: 500;
    font-size: 40rpx;
    line-height: 52rpx;

    .island-name-content {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .island-name-icon {
      margin-left: 4rpx;
    }
  }
  .island-baseinfo {
    font-size: 24rpx;
    line-height: 36rpx;
    margin-top: 2rpx;
  }
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 30rpx;
  background-color: #fff;

  &.island-header {
    padding: 12px 15px 8px;
    border-bottom: 16rpx solid #f8f8f8;
    color: #000;
  }
  .island-header {
    padding: 0 30rpx 16rpx;

    color: var(--c-white-9);

    background-color: var(--c-gray-9);
  }
}
</style>
